module.exports = __webpack_public_path__ + "static/media/backicon.4eabfda2.svg";